import React from 'react';
import PropTypes from 'prop-types';
import { getSectionColor, getSectionAbbr } from 'utils/Formatters';

const ASQSectionResults = ({ survey }) => {
  if (!survey.sections) return null;
  return (
    survey.sections.map(section => {
      const name = survey.type === 'asq_3' ? getSectionAbbr(section.nameEn) : section.score.result;
      const colorKey = section.score.resultKey || section.score.result;
      return (name &&
        <span key={section.name} className={`cs-txt--sp-${getSectionColor(colorKey)}`}>
          {name}
        </span>
      );
    })
  );
}

ASQSectionResults.propTypes = {
  survey: PropTypes.object.isRequired,
}

export default ASQSectionResults;
